import { gql } from "@apollo/client"

export const UPDATE_MEDIA = gql`
    mutation updateMedia($updateMediaInput: UpdateMediaInput) {
        updateMedia(updateMediaInput: $updateMediaInput) {
            id
        }
    }
`
